const Articles = [
  {
      id: 1,
      img: "https://i0.wp.com/farm3.static.flickr.com/2265/5719811437_f83d0f9898_z.jpg",
      title: "Tourist",
      description: "Considered one of the most elite models, the Turist was designed for long-distance rides. Its revolutionary gear system and aerodynamic design made it a favorite among cycling enthusiasts.",
  },
  {
      id: 2,
      img: "https://upload.wikimedia.org/wikipedia/commons/f/fe/UkW120_%284%29.JPG",
      title: "Ural",
      description: "Renowned for its durability, the Ural was capable of withstanding heavy workloads and rough terrain. It was favored by family men seeking a reliable means of transportation.",
  },
  {
      id: 3,
      img: "https://i2.wp.com/novate.ru/files/u34476/soviet-bike-07.jpg",
      title: "Orlenok",
      description: "A rival to the Shkolnik, the Orlenok symbolized a transition into adulthood for Soviet children. Some owners even added small engines, turning it into a mini motorbike.",
  },
  {
      id: 4,
      img: "https://d2mpxrrcad19ou.cloudfront.net/item_images/796864/10037821_fullsize.jpg",
      title: "Kama",
      description: "The Kama quickly became a bestseller despite its relatively high price. It was highly customizable, with owners often adding various accessories to personalize it.",
  },
  {
      id: 5,
      img: "https://www.velomuseum.ee/gallery/images/20130430-1337817405-saljut_0.jpg",
      title: "Shkolnik",
      description: "Produced from 1956 until the mid-1990s, the Shkolnik was a popular choice among schoolchildren, known for its durability and reliability.",
  },
  {
      id: 6,
      img: "https://mf.b37mrtl.ru/rbthmedia/images/2021.03/original/603f796615e9f916f415ac89.jpg",
      title: "Malysh",
      description: "Technically a tricycle, the Malysh is a model of simplicity, perfect for children aged three to five. Its sturdy frame even allowed older children to use it like a scooter.",
  },

];

export default Articles;